import { render, staticRenderFns } from "./TestFormQuestion.vue?vue&type=template&id=77801bb5&scoped=true&"
import script from "./TestFormQuestion.vue?vue&type=script&lang=js&"
export * from "./TestFormQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77801bb5",
  null
  
)

/* custom blocks */
import block0 from "./TestFormQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports